export default function Services() {
  return (
    <>
      {/* Hero Section */}
      <section className="relative py-24 px-margin-mobile md:px-margin-desktop bg-data-teal text-white overflow-hidden">
        <div className="max-w-container-max mx-auto relative z-10 grid md:grid-cols-2 gap-gutter items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-1 rounded-full border border-white/20">
              <span className="font-label-mono text-label-mono text-cucumber-blossom uppercase">Agricultural Precision</span>
            </div>
            <h1 className="font-headline-xl text-headline-xl md:text-[56px] leading-tight">Advanced Ecological Solutions for High-Yield Crops</h1>
            <p className="font-body-lg text-body-lg text-surface-variant max-w-xl">
              Bridging biological growth with high-accuracy technological data. We provide the scientific foundation for modern agriculture.
            </p>
          </div>
          <div className="relative hidden md:block group">
            <div className="absolute -inset-4 bg-primary/20 blur-3xl rounded-full"></div>
            <img
              className="rounded-xl shadow-2xl relative z-10 grayscale hover:grayscale-0 transition-all duration-700"
              alt="Laboratory seed assessment"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCNOQ0myoPHBA5y96tzBEtuTycT-cDwrz0pTouNqBgKBsoYRuTv6IV8NuflFZsJtn4FY-LMyRWk0hXbOurL-8Z1RTdp3Tzfh5l2IjapsXrQWmtg_WphvEeoQMLkhd0LW-VyqwA3Zao_r9QypgjOb8MRsq78IevrEuE0LUhzYzTD0yC5961_PGHPUZUNgzg4Q8u0NCOSc8kAfFe3z43GdYd4Kn4_Th3TghjAfL-SUW4Ed9E53-RKmMZB-A56fcBbSgJa_moEzUTk0Wo"
            />
          </div>
        </div>
      </section>

      {/* Services Bento Grid */}
      <section className="py-24 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto">
        <div className="mb-16">
          <span className="font-label-bold text-label-bold text-primary uppercase tracking-widest">Our Expertise</span>
          <h2 className="font-headline-lg text-headline-lg mt-2">Specialized Agri-Tech Services</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-gutter">
          {/* Service 1: Seed Quality Assessment */}
          <div className="md:col-span-8 tonal-card rounded-xl p-8 flex flex-col md:flex-row gap-8 overflow-hidden">
            <div className="flex-1 space-y-4">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>biotech</span>
              </div>
              <h3 className="font-headline-md text-headline-md text-data-teal">Seed Quality Assessment</h3>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Our proprietary real-time monitoring system evaluates vigor testing for cucumber seeds with high accuracy. Using multi-spectral imaging and machine learning, we identify growth potential before planting.
              </p>
              <ul className="space-y-3 pt-4">
                <li className="flex items-center gap-3 font-label-mono text-label-mono text-growth-green">
                  <span className="material-symbols-outlined text-[18px]">check_circle</span>
                  GERM_RATE PRECISION ANALYTICS
                </li>
                <li className="flex items-center gap-3 font-label-mono text-label-mono text-growth-green">
                  <span className="material-symbols-outlined text-[18px]">check_circle</span>
                  PATHOGEN SCREENING PROTOCOLS
                </li>
              </ul>
            </div>
            <div className="flex-1 bg-surface-container rounded-lg relative min-h-[200px] overflow-hidden">
              <img
                className="absolute inset-0 w-full h-full object-cover mix-blend-multiply opacity-80"
                alt="Seed quality assessment"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuDiLoo775acOkMcTsuhkeGlOp3orjjkkYPhPlVoTkd6xCD_nyqDWv2e66N1SvUezUEFTnqNU4W0Rewi8wgl9uvuMFYQt2BNdes5vTjZJbk9cnfqyF9AdrxTFFf4YN8BasMHPLdh_p0M-8C9IMzm3AcADw0W6-Cs0ClGR3q-8nneEtZFNDdgHf6-c5IWG7S_6DJRkFEiNkYAYjmpZ4IZ6gfZ9TIkKjA-VTwf9Z7KHrZ9vT_fSMDRT5am5j00M-q6ZX2VI-N2PObB8oY"
              />
              <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-md p-3 rounded-lg shadow-sm border border-outline-variant/30">
                <span className="font-label-mono text-[11px] text-data-teal font-bold">HIGH VIGOR INDEX</span>
              </div>
            </div>
          </div>

          {/* Service 2: IoT Solutions */}
          <div className="md:col-span-4 tonal-card rounded-xl p-8 space-y-4 bg-primary text-white">
            <div className="h-12 w-12 rounded-lg bg-white/20 flex items-center justify-center text-white">
              <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>sensors</span>
            </div>
            <h3 className="font-headline-md text-headline-md">IoT Solutions</h3>
            <p className="font-body-md text-body-md opacity-90">
              Digital tools designed for modern precision farming. Deploy field sensors that sync instantly with our cloud dashboard.
            </p>
            <div className="pt-8 space-y-4">
              <div className="bg-white/10 p-4 rounded-lg border border-white/20">
                <span className="font-label-mono text-[12px] block mb-1">SOIL_MOISTURE</span>
                <div className="h-2 w-full bg-white/20 rounded-full overflow-hidden">
                  <div className="h-full bg-cucumber-blossom w-[75%]"></div>
                </div>
              </div>
              <div className="bg-white/10 p-4 rounded-lg border border-white/20">
                <span className="font-label-mono text-[12px] block mb-1">UV_EXPOSURE</span>
                <div className="h-2 w-full bg-white/20 rounded-full overflow-hidden">
                  <div className="h-full bg-cucumber-blossom w-[42%]"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Service 3: Advisory Services */}
          <div className="md:col-span-12 tonal-card rounded-xl overflow-hidden grid md:grid-cols-2">
            <div className="p-8 md:p-12 space-y-6">
              <div className="h-12 w-12 rounded-lg bg-earth-clay/10 flex items-center justify-center text-earth-clay">
                <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>psychology</span>
              </div>
              <h3 className="font-headline-lg text-headline-lg text-data-teal">Expert Advisory Services</h3>
              <p className="font-body-lg text-body-lg text-on-surface-variant">
                Navigate the complexities of large-scale cultivation with our senior agronomists. We provide data-backed guidance on soil management, nutrient cycles, and climate adaptation.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="p-4 border-l-4 border-earth-clay bg-surface-container-low rounded-r-lg">
                  <h4 className="font-label-bold text-label-bold text-data-teal uppercase mb-1">Soil Analysis</h4>
                  <p className="font-body-sm text-body-sm">Detailed chemical and biological profiling.</p>
                </div>
                <div className="p-4 border-l-4 border-growth-green bg-surface-container-low rounded-r-lg">
                  <h4 className="font-label-bold text-label-bold text-data-teal uppercase mb-1">Growth Mapping</h4>
                  <p className="font-body-sm text-body-sm">Predictive modeling for seasonal yield.</p>
                </div>
              </div>
              <button className="flex items-center gap-2 font-label-bold text-label-bold text-primary group">
                SCHEDULE A CONSULTATION
                <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
              </button>
            </div>
            <div className="relative min-h-[300px] bg-earth-clay">
              <img
                className="absolute inset-0 w-full h-full object-cover"
                alt="Expert advisory"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuBhrrF-JspU93HkyqQ6KwQoBz7FtexZfNKDy7LuzB5LlMQzcMzqrouNnSzb_jIkcto6JC8Zxcpx7aH_HS4u6T55ONG8qfdRhPjjUqsfMQaZoDokZy1cb6eJLGKCPXwsZ8ECjLtxQAs6KZzuHbJKmdyLwbNah6oDmSPUSbQcxL57z6fm4k2ckKH3Vs8hzz6jUg5SEEI7v5pjrd4C7vraX-xUWRPa8LHzAiHAjtnxdt6zX0xnUUATFAry5La4ZmBlnDlVdpjtzWajoN8"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white md:from-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Supported By Section */}
      <section className="py-16 px-margin-mobile md:px-margin-desktop bg-surface-container-low">
        <div className="max-w-container-max mx-auto flex flex-col md:flex-row items-center justify-center gap-8">
          <p className="font-headline-md text-headline-md text-data-teal">Incubated & Supported by</p>
          <div className="bg-white p-4 rounded-xl shadow-sm">
            <img src="/IIT-Ropar-AWaDH.webp" alt="iHub-AWaDH IIT Ropar" className="h-16 object-contain" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-surface-container-high">
        <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop text-center">
          <div className="max-w-3xl mx-auto space-y-8">
            <h2 className="font-headline-lg text-headline-lg text-data-teal">Ready to optimize your crop productivity?</h2>
            <p className="font-body-lg text-body-lg text-on-surface-variant">
              Join the network of nurseries and scientists already using CAFE technology to redefine seed quality standards.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-primary text-on-primary px-8 py-4 rounded-lg font-label-bold text-label-bold uppercase tracking-widest hover:bg-on-primary-fixed-variant transition-shadow shadow-lg shadow-primary/20">
                Request Demo
              </button>
              <button className="border-2 border-primary text-primary px-8 py-4 rounded-lg font-label-bold text-label-bold uppercase tracking-widest hover:bg-primary/5 transition-colors">
                View Research Papers
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
